export default __webpack_public_path__ + "static/media/copyblue.3a4d4eb4.svg";